var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMts = function SvgMts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E30611",
    fillRule: "evenodd",
    d: "M4.42578 12.0594C4.42578 15.3326 6.23361 18.6335 10.2819 18.6335C14.3266 18.6335 16.138 15.3326 16.138 12.0594C16.138 9.82367 15.3952 7.24902 14.1553 5.16945C12.9495 3.16127 11.5008 1.9668 10.2819 1.9668C9.0596 1.9668 7.6102 3.16127 6.4149 5.16945C5.16916 7.24902 4.42578 9.82367 4.42578 12.0594Z",
    clipRule: "evenodd"
  })));
};
export default SvgMts;